function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../core-video-internal';
import { Observable } from '../../utils/observables/observable';
import { DomPlayerFullscreenManager } from '../dom-common/dom-player-fullscreen-manager';
import { ShakaPlayerEventType, VideoElementEventType } from './shaka.enums';
import { isVersionCompliant, MINIMUM_VERSION_FOR_UPSTREAM_PATCH } from './shaka-version-utils';
export var ShakaPlayerEngineItemEventsManager = /*#__PURE__*/ function() {
    "use strict";
    function ShakaPlayerEngineItemEventsManager(player) {
        var _this = this;
        _class_call_check(this, ShakaPlayerEngineItemEventsManager);
        _define_property(this, "player", void 0);
        _define_property(this, "videoElement", void 0);
        _define_property(this, "fullscreenManager", void 0);
        _define_property(this, "manifestAvailable", void 0);
        _define_property(this, "loading", void 0);
        _define_property(this, "loaded", void 0);
        _define_property(this, "buffering", void 0);
        _define_property(this, "adaptation", void 0);
        _define_property(this, "mediaQualityChanged", void 0);
        _define_property(this, "error", void 0);
        _define_property(this, "tracksChanged", void 0);
        _define_property(this, "textTracksChanged", void 0);
        _define_property(this, "emsg", void 0);
        _define_property(this, "prft", void 0);
        _define_property(this, "segmentDownloaded", void 0);
        _define_property(this, "variantChangeRequested", void 0);
        _define_property(this, "variantChangeActuated", void 0);
        _define_property(this, "timelineRegionAdded", void 0);
        _define_property(this, "largeGapDetected", void 0);
        _define_property(this, "manifestParsed", void 0);
        _define_property(this, "manifestUpdated", void 0);
        _define_property(this, "metadata", void 0);
        _define_property(this, "downloadHeadersReceived", void 0);
        _define_property(this, "timeUpdate", void 0);
        _define_property(this, "durationChanged", void 0);
        _define_property(this, "pause", void 0);
        _define_property(this, "playing", void 0);
        _define_property(this, "ended", void 0);
        _define_property(this, "seeking", void 0);
        _define_property(this, "seeked", void 0);
        _define_property(this, "canPlayThrough", void 0);
        _define_property(this, "loadingError", void 0);
        _define_property(this, "videoCreated", void 0);
        _define_property(this, "fullscreenChanged", void 0);
        _define_property(this, "play", void 0);
        _define_property(this, "handleMetadata", void 0);
        _define_property(this, "handleDownloadHeadersReceived", void 0);
        _define_property(this, "handleLoadingError", void 0);
        _define_property(this, "handleError", void 0);
        _define_property(this, "handleFullscreenChanged", void 0);
        _define_property(this, "handleCanPlayThrough", void 0);
        _define_property(this, "handleSeeked", void 0);
        _define_property(this, "handleSeekStarted", void 0);
        _define_property(this, "handleEnded", void 0);
        _define_property(this, "handlePlaying", void 0);
        _define_property(this, "handlePause", void 0);
        _define_property(this, "handleDurationChanged", void 0);
        _define_property(this, "handleTimeUpdate", void 0);
        _define_property(this, "handleManifestParsed", void 0);
        _define_property(this, "handleLargeGapDetected", void 0);
        _define_property(this, "handleTimelineRegionAdded", void 0);
        _define_property(this, "handleVariantChanged", void 0);
        _define_property(this, "handleAudioTrackChanged", void 0);
        _define_property(this, "handleEmsg", void 0);
        _define_property(this, "handlePrft", void 0);
        _define_property(this, "handleSegmentDownloaded", void 0);
        _define_property(this, "handleTextChanged", void 0);
        _define_property(this, "handleTracksChanged", void 0);
        _define_property(this, "handleAdaptation", void 0);
        _define_property(this, "handleMediaQualityChanged", void 0);
        _define_property(this, "handleLoading", void 0);
        _define_property(this, "handleLoaded", void 0);
        _define_property(this, "handleManifestUpdated", void 0);
        _define_property(this, "handleBuffering", void 0);
        _define_property(this, "handlePlay", void 0);
        this.player = player;
        this.videoElement = null;
        this.fullscreenManager = null;
        this.manifestAvailable = new Observable();
        this.loading = new Observable();
        this.loaded = new Observable();
        this.buffering = new Observable();
        this.adaptation = new Observable();
        this.mediaQualityChanged = new Observable();
        this.error = new Observable();
        this.tracksChanged = new Observable();
        this.textTracksChanged = new Observable();
        this.emsg = new Observable();
        this.prft = new Observable();
        this.segmentDownloaded = new Observable();
        this.variantChangeRequested = new Observable();
        this.variantChangeActuated = new Observable();
        this.timelineRegionAdded = new Observable();
        this.largeGapDetected = new Observable();
        this.manifestParsed = new Observable();
        this.manifestUpdated = new Observable();
        this.metadata = new Observable();
        this.downloadHeadersReceived = new Observable();
        this.timeUpdate = new Observable();
        this.durationChanged = new Observable();
        this.pause = new Observable();
        this.playing = new Observable();
        this.ended = new Observable();
        this.seeking = new Observable();
        this.seeked = new Observable();
        this.canPlayThrough = new Observable();
        this.loadingError = new Observable();
        this.videoCreated = new Observable();
        this.fullscreenChanged = new Observable();
        this.play = new Observable();
        this.handleMetadata = function(e) {
            _this.metadata.notifyObservers(e);
        };
        this.handleDownloadHeadersReceived = function(e) {
            _this.downloadHeadersReceived.notifyObservers(e);
        };
        this.handleLoadingError = function(e) {
            _this.loadingError.notifyObservers(e);
        };
        this.handleError = function(e) {
            _this.error.notifyObservers(e);
        };
        this.handleFullscreenChanged = function(isFullscreen) {
            _this.fullscreenChanged.notifyObservers(isFullscreen);
        };
        this.handleCanPlayThrough = function() {
            var // handleCanPlayThrough is used as a workaround for loading issues but the event gets fired
            // each time buffering occurs or after a seek event, so we must remove the event listener
            // after it has been fired once.
            _this_videoElement;
            _this.canPlayThrough.notifyObservers();
            (_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.removeEventListener('canplaythrough', _this.handleCanPlayThrough);
        };
        this.handleSeeked = function() {
            _this.seeked.notifyObservers();
        };
        this.handleSeekStarted = function() {
            _this.seeking.notifyObservers();
        };
        this.handleEnded = function() {
            _this.ended.notifyObservers();
        };
        this.handlePlaying = function() {
            _this.playing.notifyObservers();
        };
        this.handlePause = function() {
            _this.pause.notifyObservers();
        };
        this.handleDurationChanged = function() {
            _this.durationChanged.notifyObservers();
        };
        this.handleTimeUpdate = function(e) {
            _this.timeUpdate.notifyObservers(e);
            // 'onEnded' event does not trigger on Vidaa especially for small clips
            if (_this.shouldUseVidaaEndedWorkaround() && _this.videoElement) {
                if (_this.videoElement.currentTime >= Math.floor(_this.videoElement.duration)) {
                    _this.handleEnded();
                }
            }
        };
        this.handleManifestParsed = function() {
            _this.manifestParsed.notifyObservers();
        };
        this.handleLargeGapDetected = function(e) {
            _this.largeGapDetected.notifyObservers(e);
        };
        this.handleTimelineRegionAdded = function(e) {
            _this.timelineRegionAdded.notifyObservers(e);
        };
        this.handleVariantChanged = function() {
            _this.variantChangeRequested.notifyObservers();
        };
        this.handleAudioTrackChanged = function() {
            _this.variantChangeActuated.notifyObservers();
        };
        this.handleEmsg = function(e) {
            _this.emsg.notifyObservers(e);
        };
        this.handlePrft = function(e) {
            _this.prft.notifyObservers(e);
        };
        this.handleSegmentDownloaded = function(e) {
            _this.segmentDownloaded.notifyObservers(e);
        };
        this.handleTextChanged = function() {
            _this.textTracksChanged.notifyObservers();
        };
        this.handleTracksChanged = function() {
            _this.tracksChanged.notifyObservers();
        };
        this.handleAdaptation = function() {
            _this.adaptation.notifyObservers();
        };
        this.handleMediaQualityChanged = function(e) {
            _this.mediaQualityChanged.notifyObservers(e);
        };
        this.handleLoading = function() {
            _this.loading.notifyObservers();
        };
        this.handleLoaded = function() {
            _this.loaded.notifyObservers();
        };
        this.handleManifestUpdated = function() {
            _this.manifestUpdated.notifyObservers();
        };
        this.handleBuffering = function(e) {
            _this.buffering.notifyObservers(e);
        };
        this.handlePlay = function() {
            _this.play.notifyObservers();
        };
        this.player.addEventListener(ShakaPlayerEventType.loading, this.handleLoading);
        this.player.addEventListener(ShakaPlayerEventType.loaded, this.handleLoaded);
        this.player.addEventListener(ShakaPlayerEventType.buffering, this.handleBuffering);
        this.player.addEventListener(ShakaPlayerEventType.adaptation, this.handleAdaptation);
        this.player.addEventListener(ShakaPlayerEventType.mediaqualitychanged, this.handleMediaQualityChanged);
        this.player.addEventListener(ShakaPlayerEventType.error, this.handleError);
        this.player.addEventListener(ShakaPlayerEventType.trackschanged, this.handleTracksChanged);
        this.player.addEventListener(ShakaPlayerEventType.textchanged, this.handleTextChanged);
        this.player.addEventListener(ShakaPlayerEventType.emsg, this.handleEmsg);
        this.player.addEventListener(ShakaPlayerEventType.prft, this.handlePrft);
        this.player.addEventListener(ShakaPlayerEventType.variantchanged, this.handleVariantChanged);
        // Fired when a call from the application caused a variant change.
        this.player.addEventListener(ShakaPlayerEventType.timelineregionadded, this.handleTimelineRegionAdded);
        this.player.addEventListener(ShakaPlayerEventType.largegap, this.handleLargeGapDetected);
        this.player.addEventListener(ShakaPlayerEventType.manifestparsed, this.handleManifestParsed);
        if (isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_UPSTREAM_PATCH)) {
            // v4
            this.player.addEventListener(ShakaPlayerEventType.segmentdownloaded, this.handleSegmentDownloaded);
        } else {
            this.player.addEventListener(ShakaPlayerEventType.segmentDownloaded, this.handleSegmentDownloaded);
        }
        // to be removed when shaka v3 is phased out.
        this.player.addEventListener(ShakaPlayerEventType.manifestupdated, this.handleManifestUpdated);
        this.player.addEventListener(ShakaPlayerEventType.audiotrackchanged, this.handleAudioTrackChanged);
        // Fired when the audio track changes at the playhead.
        this.player.addEventListener(ShakaPlayerEventType.metadata, this.handleMetadata);
        this.player.addEventListener(ShakaPlayerEventType.downloadheadersreceived, this.handleDownloadHeadersReceived);
    }
    _create_class(ShakaPlayerEngineItemEventsManager, [
        {
            key: "handleVideoCreated",
            value: function handleVideoCreated(videoElement) {
                this.videoElement = videoElement;
                this.fullscreenManager = new DomPlayerFullscreenManager(this.videoElement);
                this.fullscreenManager.onFullscreenChanged(this.handleFullscreenChanged);
                this.videoElement.addEventListener(VideoElementEventType.timeupdate, this.handleTimeUpdate);
                this.videoElement.addEventListener(VideoElementEventType.durationchange, this.handleDurationChanged);
                this.videoElement.addEventListener(VideoElementEventType.pause, this.handlePause);
                this.videoElement.addEventListener(VideoElementEventType.playing, this.handlePlaying);
                if (!this.shouldUseVidaaEndedWorkaround()) {
                    this.videoElement.addEventListener(VideoElementEventType.ended, this.handleEnded);
                }
                this.videoElement.addEventListener(VideoElementEventType.seeking, this.handleSeekStarted);
                this.videoElement.addEventListener(VideoElementEventType.seeked, this.handleSeeked);
                this.videoElement.addEventListener(VideoElementEventType.canplaythrough, this.handleCanPlayThrough);
                this.videoElement.addEventListener(VideoElementEventType.play, this.handlePlay);
                this.videoCreated.notifyObservers(videoElement);
            }
        },
        {
            key: "attachPeiHandlers",
            value: function attachPeiHandlers(handlers) {
                this.videoCreated.registerObserver(handlers.onVideoElementCreated, this, {
                    renotifyLastEvent: true
                });
                this.manifestAvailable.registerObserver(handlers.onManifestAvailable, this, {
                    renotifyLastEvent: true
                });
                this.loading.registerObserver(handlers.onLoading, this, {
                    renotifyLastEvent: true
                });
                this.loaded.registerObserver(handlers.onLoaded, this, {
                    renotifyLastEvent: true
                });
                this.buffering.registerObserver(handlers.onBuffering, this, {
                    renotifyLastEvent: true
                });
                this.adaptation.registerObserver(handlers.onAdaptation, this, {
                    renotifyLastEvent: true
                });
                this.mediaQualityChanged.registerObserver(handlers.onMediaQualityChanged, this, {
                    renotifyLastEvent: true
                });
                this.error.registerObserver(handlers.onError, this, {
                    renotifyLastEvent: true
                });
                this.tracksChanged.registerObserver(handlers.onTracksChanged, this, {
                    renotifyLastEvent: true
                });
                this.textTracksChanged.registerObserver(handlers.onTextTracksChanged, this, {
                    renotifyLastEvent: true
                });
                this.emsg.registerObserver(handlers.onEsmg, this, {
                    renotifyLastEvent: true
                });
                this.prft.registerObserver(handlers.onPrft, this, {
                    renotifyLastEvent: true
                });
                this.segmentDownloaded.registerObserver(handlers.onSegmentDownloaded, this, {
                    renotifyLastEvent: true
                });
                this.variantChangeRequested.registerObserver(handlers.onVariantChangeRequested, this, {
                    renotifyLastEvent: true
                });
                this.variantChangeActuated.registerObserver(handlers.onVariantChangeActuated, this, {
                    renotifyLastEvent: true
                });
                this.timelineRegionAdded.registerObserver(handlers.onTimelineRegionAdded, this, {
                    renotifyLastEvent: true
                });
                this.largeGapDetected.registerObserver(handlers.onLargeGapDetected, this, {
                    renotifyLastEvent: true
                });
                this.manifestParsed.registerObserver(handlers.onManifestParsed, this, {
                    renotifyLastEvent: true
                });
                this.timeUpdate.registerObserver(handlers.onTimeUpdate, this, {
                    renotifyLastEvent: true
                });
                this.durationChanged.registerObserver(handlers.onDurationChanged, this, {
                    renotifyLastEvent: true
                });
                this.pause.registerObserver(handlers.onPause, this, {
                    renotifyLastEvent: true
                });
                this.playing.registerObserver(handlers.onPlaying, this, {
                    renotifyLastEvent: true
                });
                this.ended.registerObserver(handlers.onEnded, this, {
                    renotifyLastEvent: true
                });
                this.seeking.registerObserver(handlers.onSeekStarted, this, {
                    renotifyLastEvent: true
                });
                this.seeked.registerObserver(handlers.onSeekEnded, this, {
                    renotifyLastEvent: true
                });
                this.canPlayThrough.registerObserver(handlers.onCanPlayThrough, this, {
                    renotifyLastEvent: true
                });
                this.loadingError.registerObserver(handlers.onLoadError, this, {
                    renotifyLastEvent: true
                });
                this.fullscreenChanged.registerObserver(handlers.onFullscreenChanged, this, {
                    renotifyLastEvent: true
                });
                this.play.registerObserver(handlers.onPlay, this, {
                    renotifyLastEvent: true
                });
                this.manifestUpdated.registerObserver(handlers.onManifestUpdated, this, {
                    renotifyLastEvent: true
                });
                this.metadata.registerObserver(handlers.onMetadata, this, {
                    renotifyLastEvent: true
                });
                this.downloadHeadersReceived.registerObserver(handlers.onDownloadHeadersReceived, this, {
                    renotifyLastEvent: true
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_fullscreenManager;
                (_this_fullscreenManager = this.fullscreenManager) === null || _this_fullscreenManager === void 0 ? void 0 : _this_fullscreenManager.destroy();
                this.destroyPlayerEvents();
                this.destroyVideoElement();
                this.unregisterObservers();
            }
        },
        {
            key: "handleManifestAvailable",
            value: function handleManifestAvailable() {
                this.manifestAvailable.notifyObservers();
            }
        },
        {
            key: "shouldUseVidaaEndedWorkaround",
            value: function shouldUseVidaaEndedWorkaround() {
                return CoreVideoInternal.deviceType === DeviceType.Vidaa;
            }
        },
        {
            key: "destroyPlayerEvents",
            value: function destroyPlayerEvents() {
                var _this_player, _this_player1, _this_player2, _this_player3, _this_player4, _this_player5, _this_player6, _this_player7, _this_player8, _this_player9, _this_player10, _this_player11, _this_player12, _this_player13, _this_player14, _this_player15, // to be removed when shaka v3 is phased out.
                _this_player16, _this_player17;
                (_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.removeEventListener(ShakaPlayerEventType.loading, this.handleLoading);
                (_this_player1 = this.player) === null || _this_player1 === void 0 ? void 0 : _this_player1.removeEventListener(ShakaPlayerEventType.loaded, this.handleLoaded);
                (_this_player2 = this.player) === null || _this_player2 === void 0 ? void 0 : _this_player2.removeEventListener(ShakaPlayerEventType.buffering, this.handleBuffering);
                (_this_player3 = this.player) === null || _this_player3 === void 0 ? void 0 : _this_player3.removeEventListener(ShakaPlayerEventType.adaptation, this.handleAdaptation);
                (_this_player4 = this.player) === null || _this_player4 === void 0 ? void 0 : _this_player4.removeEventListener(ShakaPlayerEventType.mediaqualitychanged, this.handleMediaQualityChanged);
                (_this_player5 = this.player) === null || _this_player5 === void 0 ? void 0 : _this_player5.removeEventListener(ShakaPlayerEventType.error, this.handleError);
                (_this_player6 = this.player) === null || _this_player6 === void 0 ? void 0 : _this_player6.removeEventListener(ShakaPlayerEventType.trackschanged, this.handleTracksChanged);
                (_this_player7 = this.player) === null || _this_player7 === void 0 ? void 0 : _this_player7.removeEventListener(ShakaPlayerEventType.textchanged, this.handleTextChanged);
                (_this_player8 = this.player) === null || _this_player8 === void 0 ? void 0 : _this_player8.removeEventListener(ShakaPlayerEventType.emsg, this.handleEmsg);
                (_this_player9 = this.player) === null || _this_player9 === void 0 ? void 0 : _this_player9.removeEventListener(ShakaPlayerEventType.prft, this.handlePrft);
                (_this_player10 = this.player) === null || _this_player10 === void 0 ? void 0 : _this_player10.removeEventListener(ShakaPlayerEventType.variantchanged, this.handleVariantChanged);
                (_this_player11 = this.player) === null || _this_player11 === void 0 ? void 0 : _this_player11.removeEventListener(ShakaPlayerEventType.timelineregionadded, this.handleTimelineRegionAdded);
                (_this_player12 = this.player) === null || _this_player12 === void 0 ? void 0 : _this_player12.removeEventListener(ShakaPlayerEventType.largegap, this.handleLargeGapDetected);
                (_this_player13 = this.player) === null || _this_player13 === void 0 ? void 0 : _this_player13.removeEventListener(ShakaPlayerEventType.manifestupdated, this.handleManifestUpdated);
                (_this_player14 = this.player) === null || _this_player14 === void 0 ? void 0 : _this_player14.removeEventListener(ShakaPlayerEventType.manifestparsed, this.handleManifestParsed);
                (_this_player15 = this.player) === null || _this_player15 === void 0 ? void 0 : _this_player15.removeEventListener(ShakaPlayerEventType.downloadheadersreceived, this.handleDownloadHeadersReceived);
                if (isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_UPSTREAM_PATCH)) {
                    // v4
                    this.player.removeEventListener(ShakaPlayerEventType.segmentdownloaded, this.handleSegmentDownloaded);
                } else {
                    this.player.removeEventListener(ShakaPlayerEventType.segmentDownloaded, this.handleSegmentDownloaded);
                }
                (_this_player16 = this.player) === null || _this_player16 === void 0 ? void 0 : _this_player16.removeEventListener('audiotrackchanged', this.handleAudioTrackChanged);
                (_this_player17 = this.player) === null || _this_player17 === void 0 ? void 0 : _this_player17.removeEventListener('metadata', this.handleMetadata);
            }
        },
        {
            key: "destroyVideoElement",
            value: function destroyVideoElement() {
                var _this_videoElement, _this_videoElement1, _this_videoElement2, _this_videoElement3, _this_videoElement4, _this_videoElement5, _this_videoElement6, _this_videoElement7;
                (_this_videoElement = this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.removeEventListener('timeupdate', this.handleTimeUpdate);
                (_this_videoElement1 = this.videoElement) === null || _this_videoElement1 === void 0 ? void 0 : _this_videoElement1.removeEventListener('durationchange', this.handleDurationChanged);
                (_this_videoElement2 = this.videoElement) === null || _this_videoElement2 === void 0 ? void 0 : _this_videoElement2.removeEventListener('pause', this.handlePause);
                (_this_videoElement3 = this.videoElement) === null || _this_videoElement3 === void 0 ? void 0 : _this_videoElement3.removeEventListener('playing', this.handlePlaying);
                if (!this.shouldUseVidaaEndedWorkaround()) {
                    var _this_videoElement8;
                    (_this_videoElement8 = this.videoElement) === null || _this_videoElement8 === void 0 ? void 0 : _this_videoElement8.removeEventListener('ended', this.handleEnded);
                }
                (_this_videoElement4 = this.videoElement) === null || _this_videoElement4 === void 0 ? void 0 : _this_videoElement4.removeEventListener('seeking', this.handleSeekStarted);
                (_this_videoElement5 = this.videoElement) === null || _this_videoElement5 === void 0 ? void 0 : _this_videoElement5.removeEventListener('seeked', this.handleSeeked);
                (_this_videoElement6 = this.videoElement) === null || _this_videoElement6 === void 0 ? void 0 : _this_videoElement6.removeEventListener('canplaythrough', this.handleCanPlayThrough);
                (_this_videoElement7 = this.videoElement) === null || _this_videoElement7 === void 0 ? void 0 : _this_videoElement7.removeEventListener('play', this.handlePlay);
            }
        },
        {
            key: "unregisterObservers",
            value: function unregisterObservers() {
                this.manifestAvailable.unregisterObservers(this);
                this.loading.unregisterObservers(this);
                this.loaded.unregisterObservers(this);
                this.buffering.unregisterObservers(this);
                this.adaptation.unregisterObservers(this);
                this.mediaQualityChanged.unregisterObservers(this);
                this.error.unregisterObservers(this);
                this.tracksChanged.unregisterObservers(this);
                this.textTracksChanged.unregisterObservers(this);
                this.emsg.unregisterObservers(this);
                this.prft.unregisterObservers(this);
                this.variantChangeRequested.unregisterObservers(this);
                this.variantChangeActuated.unregisterObservers(this);
                this.timelineRegionAdded.unregisterObservers(this);
                this.largeGapDetected.unregisterObservers(this);
                this.manifestParsed.unregisterObservers(this);
                this.timeUpdate.unregisterObservers(this);
                this.durationChanged.unregisterObservers(this);
                this.pause.unregisterObservers(this);
                this.playing.unregisterObservers(this);
                this.ended.unregisterObservers(this);
                this.seeking.unregisterObservers(this);
                this.seeked.unregisterObservers(this);
                this.canPlayThrough.unregisterObservers(this);
                this.loadingError.unregisterObservers(this);
                this.videoCreated.unregisterObservers(this);
                this.fullscreenChanged.unregisterObservers(this);
                this.segmentDownloaded.unregisterObservers(this);
                this.play.unregisterObservers(this);
                this.manifestUpdated.unregisterObservers(this);
                this.metadata.unregisterObservers(this);
                this.downloadHeadersReceived.unregisterObservers(this);
            }
        }
    ]);
    return ShakaPlayerEngineItemEventsManager;
}();

//# sourceMappingURL=shaka-player-engine-item-events-manager.js.map